import * as VueGoogleMaps from 'vue2-google-maps'

import MedicalOffice from '@/modules/MedicalOfficeWidget/config/MedicalOffice'

export default {
  install(Vue, options) {
    const { apiKey } = options

    const pluginOptions = {
      load: { key: apiKey },
    }

    Vue.prototype.$sanitasMedicalService = new MedicalOffice(options)
    Vue.use(VueGoogleMaps, pluginOptions)
  },
}
